const Production = {
  Constants: {
    WEB_URL: "https://hodlpay.io",
    APP_URL: "http://localhost:3000",
    //staging
    API_BASE_URL: "https://dev.hodlpay.io/api/v1",
    //prod
    // API_BASE_URL: "https://backend.hodlpay.io/api/v1",

    LIVE_CHAT: "https://tawk.to/chat/5e76db0e8d24fc226589341c/default",
    Regions: [
      "Ashanti",
      "Greater Accra",
      "Bono",
      "Bono East",
      "Ahafo",
      "Central",
      "Eastern",
      "Northern",
      "Savanna",
      "North East",
      "Upper East",
      "Upper West",
      "Volta",
      "Oti",
      "Western",
      "Westen North",
    ],
  },
};

const Development = {
  Constants: {
    WEB_URL: "https://hodlpay.io",
    APP_URL: "http://localhost:3000",
    // staging
    API_BASE_URL: "https://dev.hodlpay.io/api/v1",
    // prod
    // API_BASE_URL: "https://backend.hodlpay.io/api/v1",
    // "API_BASE_URL": "http://104.199.41.198/api/v1",
    LIVE_CHAT: "https://tawk.to/chat/5e76db0e8d24fc226589341c/default",
    Regions: [
      "Ashanti",
      "Greater Accra",
      "Bono",
      "Bono East",
      "Ahafo",
      "Central",
      "Eastern",
      "Northern",
      "Savanna",
      "North East",
      "Upper East",
      "Upper West",
      "Volta",
      "Oti",
      "Western",
      "Westen North",
    ],
  },
};

export default process.env.NODE_ENV === "production"
  ? Production.Constants
  : Development.Constants;
